import { AxiosHttpClient } from "../httpClient/axios-http-client.service";
import { Person } from "../unit/unit.service";

export type CreatePersonInput = {
  unit_id: string;
  name: string;
  email?: string;
  phone?: string;
  date_of_birth?: string;
  date_baptism?: string;
};

export type UpdatePersonInput = CreatePersonInput;

export class PersonService extends AxiosHttpClient {
  public static async create(input: CreatePersonInput): Promise<Person> {
    const { data: { data } } = await this.axiosHttpClient.post("/people", input);
    return data;
  }

  public static async update(personId: string, input: UpdatePersonInput): Promise<Person> {
    const { data: { data } } = await this.axiosHttpClient.put(`/people/${personId}`, input);
    return data;
  }

  public static async remove(personId: string): Promise<void> {
    await this.axiosHttpClient.delete(`/people/${personId}`);
  }
}
